<template>
  <div class="confirm-change-before-route">
    <slot></slot>
    <confirm-dialog
      ref="confirm-before-route-leave"
    ></confirm-dialog>
  </div>
</template>

<script>
    import ConfirmDialog from '../dialog/ConfirmDialog'

    export default {
      name: 'ConfirmChangeBeforeRoute',
      components: { ConfirmDialog },
      data () {
        return {
          isConfirm: false

        }
      },
      methods: {
        change () {
          this.isConfirm = true
        },
        reset () {
          this.isConfirm = false
        },
        openConfirm () {
          if (this.isConfirm) {
            return this.$refs['confirm-before-route-leave'].open({
              message: '入力中のデータが保存されていません。<br>このページを移動すると入力中のデータが失われますが、移動しますか？',
              btnOk: '移動する'
            })
          }
          return Promise.resolve(true)
        }
      },
      mounted () {
        const form = this.$el.querySelector('form')
        form.addEventListener('change', this.change)
      }
    }
</script>

<style scoped>

</style>
